import React, { useState, useContext, useEffect, useRef } from "react";
import {
  Table,
  Menu,
  Popover,
  Pagination,
  IconButton,
  MoreIcon,
  ListDetailViewIcon,
  EyeOpenIcon,
  Position,
  ArrowUpIcon,
  ArrowDownIcon,
  Pane,
  TextDropdownButton,
  Spinner,
  Heading,
  SearchInput,
  SideSheet,
  DocumentOpenIcon,
  Icon,
  Paragraph,
  SelectField,
  TrashIcon,
  Button,
  AddIcon,
  Label,
} from "evergreen-ui";
import moment from "moment";
import CaseDetails from "../components/CaseDetails";
import FilterComponent from "../components/FilterComponent/FilterComponent";
import { globalContext } from "../global/Store";
import { Case, Lookup } from "../global/Types";
import { OverlayChildren } from "react-bootstrap/esm/Overlay";
import "./currencyWrap.css";
import { dataRepoContext } from "../data-repo/DataRepo";

export const HomeTable = (props: any) => {
  const Order = {
    NONE: "NONE",
    ASC: "ASC",
    DESC: "DESC",
  };

  const caseDataColumnNames = [
    {
      dbName: "caseRef",
      name: "Case Ref",
      order: 1,
    },
    {
      dbName: "applicantName",
      name: "Applicant Name",
      order: 2,
    },
    {
      dbName: "dateOfReferral",
      name: "Date Of Referral",
      order: 3,
    },
    {
      dbName: "referredBy",
      name: "Referred By",
      order: 4,
    },
    {
      dbName: "development",
      name: "Development",
      order: 5,
    },
    {
      dbName: "status",
      name: "Status",
      order: 6,
    },
    {
      dbName: "offerExpiryDate",
      name: "Offer Expiry Date",
      order: 7,
    },
    {
      dbName: "advisor",
      name: "Advisor",
      order: 8,
    },
    {
      dbName: "X",
      name: "X",
      order: 9,
    },
  ];

  const didMountRef = useRef(false);
  const { globalState, dispatch, globalFunctions } = useContext(globalContext);
  const { globalDataRepo } = useContext(dataRepoContext);
  const pageSize = 25;
  const [showCaseDetails, setShowCaseDetails] = useState(false);
  const [caseList, setCaseList] = useState([]);
  const [filteredCaseList, setFilteredCaseList] = useState([]);
  const [currentPageData, setCurrentPageData] = useState([]);
  const [selectedCase, setSelectedCase] = useState(0);
  const [selectedSearchFilter, setSelectedSearchFilter] = useState("");
  const [selectedDevelopmentFilter, setSelectedDevelopmentFilter] =
    useState("clearFilterAll");
  const [selectedstatusFilter, setSelectedStatusFilter] =
    useState("clearFilterAll");
  const [nextPage, setNextPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(5);
  const [totalCases, setTotalCases] = useState(0);
  const [pageFirstCase, setPageFirstCase] = useState(0);
  const [pageLastCase, setPageLastCase] = useState(25);
  const [orderedColumn, setOrderedColumn] = useState(0);
  const [ordering, setOrdering] = useState(Order.NONE);
  const [refreshIncrement, setRefreshIncrement] = useState(0);
  //const caseListType, setCaseListType] = useState(props.caseListType); //all cases or user only cases

  //handles search filter waiting for typing to complete
  useEffect(() => {
    if (didMountRef.current === true) {
      const delayDebounceFn = setTimeout(() => {
        //don't run on page load
        filterCases(
          selectedDevelopmentFilter,
          selectedstatusFilter,
          selectedSearchFilter,
          false
        );
      }, 1000);
      return () => clearTimeout(delayDebounceFn);
    }
  }, [selectedSearchFilter]);

  useEffect(() => {
    //don't run on page load
    if (didMountRef.current === true) {
      filterCases(
        selectedDevelopmentFilter,
        selectedstatusFilter,
        selectedSearchFilter,
        false
      );
    }
  }, [orderedColumn, ordering]);

  useEffect(() => {
    var clPromise = globalDataRepo
      .GetCaseList(props.caseListType, false)
      .then(function (response: any) {
        var _userName =
          globalState.user.forename + " " + globalState.user.surname;


          console.log("Cases Reloaded xxx");
          console.log(props.reloadList);
  
        setCaseList(response);
        var filteredData = 
            response.filter((x: any) => {
              return x["caseStatusId"] !== 65;
            });
        setFilteredCaseList(filteredData);
        setTotalCases(filteredData.length);
        setPageLastCase(
          filteredData.length < pageSize ? response.length : pageSize
        );
        setTotalPages(Math.ceil(filteredData.length / pageSize));
        didMountRef.current = true;
        //filterCases('clearFilterAll','clearFilterAll','', true);
      });
  }, [props.reloadList, refreshIncrement]);

  const handlePreviousPageChange = () => {
    var _previousPage = currentPage - 1;
    setCurrentPage(_previousPage);
    setPageFirstCase(pageFirstCase - pageSize);
    setPageLastCase(pageLastCase - pageSize);
  };

  const handleNextPageChange = () => {
    var _nextPage = currentPage + 1;
    setCurrentPage(_nextPage);
    setPageFirstCase(pageFirstCase + pageSize);
    setPageLastCase(pageLastCase + pageSize);
  };

  const handlePageChange = (e: number) => {
    setCurrentPage(e);
    setPageFirstCase(pageSize * (e - 1));
    setPageLastCase(pageSize * e);
  };

  const handleCloseCaseDetails = () => {
    setRefreshIncrement(refreshIncrement + 1);
    setShowCaseDetails(false);
  };

  const handleUpdateList = () => {
    setRefreshIncrement(refreshIncrement + 1);
  };

  const filtersApplied = (i: string, flg: string) => {
    if (flg === "dev") {
      setSelectedDevelopmentFilter(i);
      filterCases(i, selectedstatusFilter, selectedSearchFilter, false);
    }

    if (flg === "status") {
      setSelectedStatusFilter(i);
      filterCases(selectedDevelopmentFilter, i, selectedSearchFilter, false);
    }

    if (flg === "clearFilter") {
      setOrderedColumn(0);
      setOrdering(Order.NONE);
      setSelectedDevelopmentFilter("clearFilterAll");
      setSelectedStatusFilter("clearFilterAll");
      setSelectedSearchFilter("");
      filterCases(i, i, "", true);
    }
  };

  const renderDevelopmentName = (id: number) => {
    var _dev = globalState.developments.find((x: any) => x.id === id);
    return _dev !== undefined ? _dev.name : "";
  };

  const renderCaseStatustName = (id: number) => {
    var _status = globalState.caseStatuses.find((x: any) => x.id === id);
    return _status !== undefined ? _status.description : "";
  };

  const getIconForOrder = (column: number, order: any) => {
    var ret = null;
    if (column === orderedColumn) {
      ret = order === Order.DESC ? ArrowDownIcon : ArrowUpIcon;
    }

    return ret;
  };

  const handleOrderArrow = (column: number) => {
    //_caseColumnName.order

    if (orderedColumn !== column) {
      return Order.NONE;
    } else {
      //return this.state.ordering === Order.ASC ? Order.DESC : Order.ASC;

      return ordering !== Order.DESC ? Order.DESC : Order.ASC;
    }
  };

  const filterCases = (
    _development: string,
    _status: string,
    _search: string,
    clear_All: boolean
  ) => {
    const orderArray = (dataArray: any) => {
      switch (orderedColumn) {
        case 1: //case ref
          dataArray.sort((a: any, b: any) =>
            a.caseRef > b.caseRef ? 1 : -1
          );
          break;

        case 2: //applicant
          dataArray.sort((a: any, b: any) =>
            a.applicant > b.applicant ? 1 : -1
          );
          break;

        case 3: //referral date
          dataArray.sort((a: any, b: any) =>
            a.dateOfReferral > b.dateOfReferral
              ? 1
              : -1
          );
          break;

        case 4: //referral user
          dataArray.sort((a: any, b: any) =>
            a.referralUser > b.referralUser ? 1 : -1
          );
          break;

        case 5: //development name
          dataArray.sort((a: any, b: any) =>
            a.development > b.development ? 1 : -1
          );
          break;

        case 6: //case status
          dataArray.sort((a: any, b: any) =>
            a.caseStatus > b.caseStatus ? 1 : -1
          );
          break;

        case 7: //offer expiry date
          dataArray.sort((a: any, b: any) =>
            a.offerExpiryDate > b.offerExpiryDate
              ? 1
              : -1
          );
          break;

        case 8: // advisor
          dataArray.sort((a: any, b: any) =>
            a.advisor > b.advisor ? 1 : -1
          );
          break;
      }

      if (ordering === Order.DESC) {
        dataArray.reverse();
      }

      return dataArray;
    };

    const searchArray = (dataArray: any, _srch: any) => {
      _srch = _srch.trim().toUpperCase();

      if (_srch !== "") {

        dataArray = dataArray.filter((a: any) => {
          return ((a.applicant || "").toUpperCase().includes(_srch)
          || (a.caseRef || "").toUpperCase().includes(_srch)
          || (a.referralUser || "").toUpperCase().includes(_srch)
          // || (a.development || "").toUpperCase().includes(_srch)
          // || (a.caseStatus || "").toUpperCase().includes(_srch)
          || (a.advisor || "").toUpperCase().includes(_srch)
          );
        });


        // dataArray = dataArray.filter(function(item: any) {
        //   for (var key in _srch) {
        //     if (item[key] === undefined || item[key] != _srch[key])
        //       return false;
        //   }
        //   return true;
        // });



      } else {
        console.log("no filter");
      }

      return dataArray;
    };

    if (
      clear_All === true ||
      (_development === "clearFilterAll" && _development === "clearFilterAll")
    ) {
      var filteredData = searchArray(
        orderArray(
          caseList.filter((x) => {
            return x["caseStatusId"] !== 65;
          })
        ),
        _search
      );
      setFilteredCaseList(filteredData);
      setTotalPages(Math.ceil(filteredData.length / pageSize));
    }

    if (clear_All !== true) {
      if (_development === "clearFilterAll" && _status !== "clearFilterAll") {
        var filteredData = searchArray(
          orderArray(
            caseList.filter((x) => {
              return x["caseStatusId"] === +_status;
            })
          ),
          _search
        );
        setFilteredCaseList(filteredData);
        setTotalPages(Math.ceil(filteredData.length / pageSize));
      }

      if (_status === "clearFilterAll" && _development !== "clearFilterAll") {
        var filteredData = searchArray(
          orderArray(
            caseList
              .filter((x) => {
                return x["developmentId"] === +_development;
              })
              .filter((x) => {
                return x["caseStatusId"] !== 65;
              })
          ),
          _search
        );
        setFilteredCaseList(filteredData);
        setTotalPages(Math.ceil(filteredData.length / pageSize));
      }

      if (_development !== "clearFilterAll" && _status !== "clearFilterAll") {
        var filteredData = searchArray(
          orderArray(
            caseList
              .filter((x) => {
                return x["developmentId"] === +_development;
              })
              .filter((x) => {
                return x["caseStatusId"] === +_status;
              })
          ),
          _search
        );
        setFilteredCaseList(filteredData);
        setTotalPages(Math.ceil(filteredData.length / pageSize));
      }
    }

    setCurrentPage(1);
    setPageFirstCase(0);
    setPageLastCase(25);
  };

  const handleSelectCase = (_case: any) => {
    setSelectedCase(_case.id);
    setShowCaseDetails(true);
  };

  const renderTableHeaderCell = (_caseColumnName: any) => {
    if (_caseColumnName.order === 9) {
      return (
        <Table.TextHeaderCell
          width={48}
          flex="none"
          key={_caseColumnName.order}
        ></Table.TextHeaderCell>
      );
    }

    if (_caseColumnName.order !== 9) {
      return (
        <Table.TextHeaderCell key={_caseColumnName.order}>
          <TextDropdownButton
            style={{ fontSize: "14px" }}
            onClick={() => {
              setOrderedColumn(_caseColumnName.order);
              setOrdering(handleOrderArrow(_caseColumnName.order));
            }}
            icon={getIconForOrder(_caseColumnName.order, ordering)}
          >
            {_caseColumnName.name}
          </TextDropdownButton>
        </Table.TextHeaderCell>
      );
    }
  };

  const renderRowMenu = (_case: any) => {
    var caseStatusObject = globalState.caseStatuses.find(
      (x: any) => x.id === _case.caseStatusId
    );
    var caseStatus =
      caseStatusObject?.description !== undefined
        ? (caseStatusObject?.description as string)
        : "";

    return (
      <Menu>
        <Menu.Group>
          {/* <Menu.Item onClick={() => this.setState({ showCaseDetails: true, formTitle: 'Edit', selectedCase: _case })}>View...</Menu.Item> */}
          <Menu.Item onClick={() => handleSelectCase(_case)}>View...</Menu.Item>
        </Menu.Group>
      </Menu>
    );
  };

  const renderRow = (_case: any, index: Number) => {
    return (
      <div key={_case.caseRef + "," + index}>
        <Table.Row isSelectable style={{ background: getRowColour(_case) }}>
          <Table.TextCell>{_case.caseRef}</Table.TextCell>
          <Table.TextCell>
            {_case.applicant !== undefined ? _case.applicant : null}
          </Table.TextCell>
          <Table.TextCell>
            {_case.dateOfReferral !== "0001-01-01T00:00:00"
              ? moment(_case.dateOfReferral).format("DD/MM/YYYY")
              : ""}
          </Table.TextCell>
          <Table.TextCell>{_case.referralUser}</Table.TextCell>
          <Table.TextCell>
            {_case.development}
          </Table.TextCell>
          <Table.TextCell>
            {_case.caseStatus}
          </Table.TextCell>
          <Table.TextCell>
            {_case.offerExpiryDate !== "0001-01-01T00:00:00"
              ? moment(_case.offerExpiryDate).format("DD/MM/YYYY")
              : ""}
          </Table.TextCell>
          <Table.TextCell>
            {_case.advisor !== null ? _case.advisor : ""}
          </Table.TextCell>
          <Table.Cell width={48} flex="none">
            <IconButton
              icon={EyeOpenIcon}
              height={24}
              appearance="minimal"
              onClick={() => handleSelectCase(_case)}
            />
            {/* <Popover
              content={renderRowMenu(_case)}
              position={Position.BOTTOM_RIGHT}
            >
              <IconButton icon={EyeOpenIcon} height={24} appearance="minimal" />
            </Popover> */}
          </Table.Cell>
        </Table.Row>
        {/* <Pane>
          {this.state.data}
        </Pane> */}
      </div>
    );
  };

  const getRowColour = (_case: any) => {
    var timeFormat = "hh:mm:ss";
    var caseDateTimeFormat = moment(
      _case.dateOfReferral,
      "YYYY-MM-DDTHH:mm:ss.SSSS"
    ).format("YYYY-MM-DDTHH:mm:ss");

    var caseDateTime = moment(caseDateTimeFormat),
      dayEnd = moment("17:00:00", timeFormat),
      nextDayStart = moment("09:00:00", timeFormat).add(1, "days");

    var currentDate = moment();
    var caseDate = moment(_case.dateOfReferral);

    if (_case.caseStatusId == 66 && _case.advisor == null)
      return "rgba(51, 102, 255, 0.1";
    if (_case.caseStatusId == 27 && _case.advisor == null)
      return "rgba(82, 189, 149, 0.1";
    if (
      _case.caseStatusId !== 66 &&
      _case.advisor == null &&
      !moment(caseDateTime).isBetween(dayEnd, nextDayStart)
    ) {
      if (currentDate.diff(caseDate, "minutes") >= 120)
        return "rgba(209, 67, 249, 0.1)";
      if (currentDate.diff(caseDate, "minutes") >= 90)
        return "rgba(255, 140, 0, 0.1)";
      if (currentDate.diff(caseDate, "minutes") >= 60)
        return "rgba(165,213,213)";
    }
  };

  const items = filteredCaseList.slice(pageFirstCase, pageLastCase);

  console.log("ITEMS");
  console.log(items);

  return (
    <>
      {showCaseDetails ? (
        <CaseDetails
          formTitle={"TEST"}
          selectedCase={selectedCase}
          onCaseDetailsComplete={handleCloseCaseDetails}
          onRefreshList={handleUpdateList}
        />
      ) : null}
      <FilterComponent reloadComponent={props.reloadList + refreshIncrement} sendCaseToParent={filtersApplied}></FilterComponent>
      <div style={{ position: "absolute", right: "80px", marginTop: "-43px" }}>
        <SearchInput
          className="searchStyle"
          height={35}
          marginTop={5}
          width={150}
          onChange={(e: any) =>
            e !== selectedSearchFilter
              ? setSelectedSearchFilter(e.target.value)
              : null
          }
          // onChange={(e: any) =>
          //   e !== selectedSearchFilter ? console.log("do nothing") : null
          // }

          value={selectedSearchFilter}
          placeholder="Search..."
        />
      </div>

      {items.length > 0 ? (
        <div style={{ margin: "50px 50px 50px 50px" }}>
          <Pagination
            onPreviousPage={() => handlePreviousPageChange()}
            onNextPage={() => handleNextPageChange()}
            onPageChange={(e: number) => handlePageChange(e)}
            page={currentPage}
            totalPages={totalPages}
          ></Pagination>
        </div>
      ) : null}
      {props.caseListType == 2 ? (
        <div style={{ margin: "20px 50px 20px 60px" }}>
          <p>My Cases</p>
        </div>
      ) : null}
      <Table className="mainTableStyle">
        <Table.Head className="mainTableHeaderStyle">
          {caseDataColumnNames.length > 0
            ? caseDataColumnNames.map((_caseColumnName) =>
                renderTableHeaderCell(_caseColumnName)
              )
            : null}
        </Table.Head>
        {items.length > 0 ? (
          <Table.Body className="mainTableBodyStyle">
            {items.map((_case, index) => renderRow(_case, index))}
          </Table.Body>
        ) : null}
      </Table>
    </>
  );
};